import React from "react";
import request from "arcdynamic-request";
import {BUYERS} from "../../consts/tables";
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";
import { ApolloConsumer } from "@apollo/client";
import { GET_BUYERS } from "../Graphql/Queries/BuyersQuery";
import { GET_BUYER_DD_QUERY, GET_BUYER_LIST_QUERY } from "../Graphql/ContactsQueries/contactsQuery";
import { fetchData } from "../Service/graphQlService";

const cloneDeep = require("lodash.clonedeep");
//const limit = 1000;

class SelectBuyer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
        };
        this.client = null;

    }

    componentDidMount() {
        //if condition added newly
        if(this.client){
        this.fetch(0);
        }
    }

    fetch(offset) {
        // request(arc.path.api, {
        //     service: "arcimedes",
        //     action: "open.datasource.table.Data.getData",
        //     params: [
        //         "code",
        //         BUYERS,
        //         {
        //             limit: {
        //                 count: limit,
        //                 offset: offset * limit,
        //             },
        //             column: [
        //                 "ARCIMEDES_ROW_ID",
        //                 "FIRST_NAME",
        //                 "LAST_NAME",
        //                 "COMPANY_NAME",
        //             ],
        //             filter: [
        //                 {
        //                     code: "DELETED",
        //                     text: "",
        //                     type: "null",
        //                 },
        //             ],
        //             order: [
        //                 {
        //                     code: "FIRST_NAME",
        //                     type: "asc",
        //                 },
        //                 {
        //                     code: "LAST_NAME",
        //                     type: "asc",
        //                 },
        //                 {
        //                     code: "COMPANY_NAME",
        //                     type: "asc",
        //                 },
        //             ],
        //         },
        //     ],
        // var pageParams = {
        //     page: 1,
        //     pageSize: 30000
        // }
        let page = offset + 1;
        var limit = 5000*page;
        var pageParams = {
			page: page,
			pageSize: 5000
		}
        let filters = [
            // {
            //   "DELETED": null
            // }
          ]
          const sortOptions = [
            {
                "field": "first_name",
                "order": "asc"
              },
               {
                "field": "last_name",
                "order": "asc"
              },
               {
                "field": "company_name",
                "order": "asc"
              }
          ]
          fetchData(GET_BUYER_DD_QUERY,{type:"Investor", pageOptions: pageParams, filters: filters, sortOptions: sortOptions })
        // const token = localStorage.getItem('authToken');
        // this.client.query({
        //     // query: GET_BUYERS, variables: { pageOptions: pageParams, filters: filters, sortOptions: sortOptions }, fetchPolicy: "no-cache",
        //     query: GET_BUYER_LIST_QUERY, variables: {type:"Buyer", pageOptions: pageParams, filters: filters, sortOptions: sortOptions }, fetchPolicy: "no-cache",
        //     context: {
        //         headers: {
        //             authorization: `Bearer ${token}`, // Bearer token added here
        //         },
        //     }
        // })
        .then(res => {
            this.setState((prevState) => {
                //const data = res.data && res.data.filter(item => item.FIRST_NAME !== '' || item.LAST_NAME !== '' || item.COMPANY_NAME !== '')
                var data = res.data && res.data.getContacts.data.filter(item => item.first_name !== '' || item.last_name !== '' || item.company_name !== '')
                // console.log('Updated data', data)
                //data = data.filter(x => x.company_name != null) // added to avoid Buyer DD issue in BuySide Agent
                data = data.filter(item => {
                    const firstName = item.first_name !== null && item.first_name !== undefined ? item.first_name.trim() : "";
                    const lastName = item.last_name !== null && item.last_name !== undefined ? item.last_name.trim() : "";
                    
                    return firstName !== "" && lastName !== "";
                  });
                const items = prevState.items.concat(data);
                return {
                    items,
                };
            });
            // if (res.data.length >= limit) {
            //     this.fetch(++offset);
            // }
            if (res.data.getContacts.totalCount >= limit) {
                this.fetch(++offset);
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.newBuyer !== nextProps.newBuyer) {
            const items = cloneDeep(this.state.items);
            items.push(nextProps.newBuyer);
            this.setState({items});
        }
    }

    render() {
        const {items} = this.state;
        const {
            theme,
            value,
            valueKey,
            label,
            disabled,
            data,
            withAddNew,
            hasDrawer,
            handleParentChange,
            addNewItem,
            deleted,
            viewMode,
            ...rest
        } = this.props;
 
        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) {
                        this.client = client;
                    }
                    return (
            <Dropdown
                theme={theme}
                optionsType="buyer"
                optionKey="contact_id"
                options={items}
                value={value}
                valueKey={valueKey}
                label={label}
                disabled={!items || disabled}
                data={data}
                withAddNew={withAddNew}
                hasDrawer={hasDrawer}
                handleParentChange={handleParentChange}
                addNewItem={addNewItem}
                deleted={deleted}
                viewMode={viewMode}
                {...rest}
            />
        )
    }}
</ApolloConsumer>
        );
    }
}

SelectBuyer.propTypes = {
    theme: PropTypes.oneOf(["default", "white", "dark"]),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    withAddNew: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    viewMode: PropTypes.bool,
    hasDrawer: PropTypes.bool,
    addNewItem: PropTypes.func,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
};

export default SelectBuyer;
